/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Reason_DamagedInputs */

const vi_warehouse_defects_reason_damaged = /** @type {(inputs: Warehouse_Defects_Reason_DamagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hư hỏng`)
};

/**

* @param {Warehouse_Defects_Reason_DamagedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_reason_damaged = /** @type {((inputs?: Warehouse_Defects_Reason_DamagedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Reason_DamagedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_reason_damaged(inputs)
});